<template>
  <div>
    <form class="formulariopadrao" @submit.prevent="submitForm" method="POST">
      <div class="lp_newsletter">
        <input type="hidden" name="_token" :value="this.token" />
        <h4>Newsletter</h4>
        <div class="label-float">
          <input
            aria-label="Seu nome"
            type="text"
            name="name"
            placeholder=" "
            v-model="form.name"
            required
          />
          <label>Nome e Sobrenome</label>
        </div>
        <div class="label-float">
          <input
            aria-label="Seu e-mail"
            type="email"
            name="email"
            placeholder=" "
            v-model="form.email"
            required
          />
          <label>Seu email favorito</label>
        </div>
        <button type="submit" :disabled="disabled">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          {{ button }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      button: "ENTRAR NA LISTA",
      disabled: false,
      form: {
        email: "",
        name: "",
      },
    };
  },
  methods: {
    resetForm() {
      this.form = {
        email: "",
        name: "",
      };
    },
    submitForm() {
        this.button = "PREPARANDO...";
        this.disabled = true;
        axios
          .post(this.endpoint, this.form)
          .then((response) => {
            this.resetForm();
            var msg = "E-mail enviado com sucesso!";
            this.$swal("Enviado :)", msg, "success");
          })
          .catch((e) => {
            var msg =
              "Houve um erro ao enviar seus dados! Por favor, tente novamente.";
            this.$swal("Oops!", msg, "error");
          })
          .finally(() => {
            this.button = "ENTRAR NA LISTA";
            this.disabled = false;
          });
    },
  },
  props: ["endpoint", "token"],
};
</script>

<style lang="scss">
@import "resources/assets/sass/website/_variables.scss";

.lp_newsletter {
  margin-bottom: 40px;
  @media (max-width: 996px){
    width: 100%;
  }
  .label-float {
    position: relative;
  }
  h4 {
    color: black;
    font-size: 28px;
    font-family: $font-inter;
    font-weight: bold;
    margin-bottom: 10px;
    @media (max-width: 996px){
      text-align: center;
    }
    @media (max-width: 575px){
      font-size: 20px;

    }
  }
  input {
    background-color: #e9e9e9;
    border: none;
    margin-bottom: 20px;
    outline: none;
    height: 50px;
    transition: all 0.3s ease-out;
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    width: 100%;
    @media (max-width: 500px){
      height: 40px;
    }
  }
  input:focus {
    border-bottom: 2px solid gray;
  }
  label-float input::placeholder {
    color: transparent;
  }
  label {
    color: #5f5f5f;
    font-family: $font-inter;
    font-size: 16px;
    position: absolute;
    pointer-events: none;
    margin-top: 13px;
    left: 16px;
    transition: all 0.3s ease-out;
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    @media (max-width: 575px){
      font-size: 13px;
      margin-top: 11px;
    }
  }
  input:focus ~ label,
  input:not(:placeholder-shown) ~ label {
    color: #4d4d4d;
    top: -28px;
    left: 0px;
    font-size: 13px;
  }
  button {
    background-color: #4B4B4B;
    border: none;
    outline: none;
    color: white;
    font-family: $font-inter;
    font-size: 20px;
    text-align: center;
    align-items: center;
    justify-content: center;
    display: flex;
    width: 100%;
    height: 50px;
    @media (max-width: 575px){
      height: 40px;
      font-size: 15px;
    }
  }
}
</style>
